import { AdSortByEnum } from '@/__generated_graphql__/graphql';
import { CategoriesFilter } from '@/components/CategoriesFilter/CategoriesFilter';
import { ChipsFilter } from '@/components/ChipsFilter/ChipsFilter';
import { RegionsFilter } from '@/components/RegionsFilter/RegionsFilter';
import { SalaryFilter } from '@/components/SalaryFilter/SalaryFilter';
import {
  EDUCATIONS,
  EXPERIENCES,
  FilterTypeEnum,
  MAX_SALARY_VALUE,
  MIN_SALARY_VALUE
} from '@/constants/common';
import { GET_EDUCATIONS, GET_EXPERIENCES } from '@/graphql/queries';
import { FiltersData, FormValues } from '@/types';

export const DEFAULT_VALUES: FormValues = {
  categories: [],
  regions: [],
  educations: [],
  experiences: [],
  salaryFrom: MIN_SALARY_VALUE,
  salaryTo: MAX_SALARY_VALUE,
  sortBy: AdSortByEnum.Recommended,
  searchTerm: ''
};

export const FILTERS: FiltersData[] = [
  {
    name: 'Filter.categories',
    children: <CategoriesFilter />,
    formField: 'categories',
    type: FilterTypeEnum.MULTIPLE
  },
  {
    name: 'Filter.city',
    children: <RegionsFilter />,
    formField: 'regions',
    type: FilterTypeEnum.MULTIPLE
  },
  {
    name: 'Filter.salary',
    children: <SalaryFilter />,
    formField: ['salaryFrom', 'salaryTo'],
    type: FilterTypeEnum.RANGE
  },
  {
    name: 'Filter.education',
    children: (
      <ChipsFilter
        query={GET_EDUCATIONS}
        fieldName={EDUCATIONS}
        formField={EDUCATIONS}
      />
    ),
    formField: EDUCATIONS,
    type: FilterTypeEnum.MULTIPLE
  },
  {
    name: 'Filter.experience',
    children: (
      <ChipsFilter
        query={GET_EXPERIENCES}
        fieldName={EXPERIENCES}
        formField={EXPERIENCES}
      />
    ),
    formField: EXPERIENCES,
    type: FilterTypeEnum.MULTIPLE
  }
];
